//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import bus from "../LandMapNq/js/bus";
import * as maptalks from "maptalks";
import TalksMap from "../LandMapNq/js/initMapTalksAgr";
import MapRightInfo from "./MapRightInfo.vue";
import MapRightDevice from "./MapRightDevice.vue";
import Videos from "../../Videos.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "LandMap",
  props:['SearchName','MasterId','height'],
  data() {
    return {
      TalksMap: new TalksMap(),
      showRightInfo: false, // 是否显示右侧信息
      showDeviceInfo: false, //是否显示右侧设备信息
      curPolygonVal: {}, //点击某块的数据
      currentIndex: 0,
      monitorTypeId: "",
      videoDialog: false,
      videoDialog2: false,
      packBtn: true,
      showBtn: false,
      landId: "",
      deviceCode: "",
      loadingFlag: false,
      deviceSingle: [
        {
          deviceTypeId: "",
          monitor_type_name: "全部设备",
          light_img: require("@/assets/agricultural/nqfont/all_icon.png"),
        },
      ],
      deviceType: [
        {
          deviceTypeId: "",
          monitor_type_name: "全部设备",
          light_img: require("@/assets/agricultural/nqfont/all_icon.png"),
        },
        {
          deviceTypeId: "10",
          monitor_type_name: "环境监测",
          light_img: require("@/assets/agricultural/nqfont/nq_icon1.png"),
        },
        {
          deviceTypeId: "20",
          monitor_type_name: "土壤监测",
          light_img: require("@/assets/agricultural/nqfont/nq_icon2.png"),
        },
        {
          deviceTypeId: "30",
          monitor_type_name: "长势监测",
          light_img: require("@/assets/agricultural/nqfont/nq_icon3.png"),
        },
        {
          deviceTypeId: "40",
          monitor_type_name: "视频监测",
          light_img: require("@/assets/agricultural/nqfont/nq_icon4.png"),
        },
      ],
      packImg: require("@/assets/agricultural/nqfont/pack_icon.png"),
      deviceFlag: true,
      landData: [],
      deviceData: [],
      deviceName: "",
      farmAllData: {},
      masterId: "",
    };
  },
  components: {
    MapRightInfo,
    MapRightDevice,
    Videos,
  },
  // props: {
  //   height: {
  //     type: String,
  //     // default: "670px",
  //     default: "100%",
  //   },
  //   height: {
  //     type: String,
  //     // default: "670px",
  //     default: "100%",
  //   },
  // },
  mounted() {
    console.log(this.$store.state.Agricultural);
    this.getMapInit();
  },
  created() {
  },
  watch: {
    'SearchName':{
      handler: function (n) {
        console.log(n);
        this.getMapData()
      },
      
    },
    'MasterId':{
      handler: function (n) {
        console.log(n);
        this.getMapData()
      },
      
    }
  },
  destroyed() {
    this.$bus.$off("changeRightInfo");
  },
  computed:{
    ...mapState("Agricultural", {
      changeSearchName: (state) => state.searchName,
    }),
    showTrajectoryMulti() {
      const { changeSearchName } = this;
      return { changeSearchName };
    },
  },
  methods: {
    // 设备切卡展开收起
    handleChangeTopInfo() {
      this.packBtn = false;
      this.showBtn = true;
      this.deviceFlag = false;
    },
    handleChangePackInfo() {
      this.packBtn = true;
      this.showBtn = false;
      this.deviceFlag = true;
    },
    // 视频放大功能
    getVideoStatus(val) {
      console.log(val);
      this.videoDialog = val;
      this.videoDialog2 = true;
      this.$refs.Videos.fn();
    },
    updatefun2(val) {
      console.log(val);
      this.videoDialog2 = val;
    },
    //初始化地图
    getMapInit() {
      this.TalksMap.init("mapDiv", 17);
      this.allPointLayer = new maptalks.VectorLayer("point").addTo(
        this.TalksMap.map
      );
      this.TalksMap.map.setMinZoom(4);
      this.TalksMap.map.setZoom(17);
      this.getMapData();
    },
    // 获取地图上的数据
    getMapData() {
      this.loadingFlag = true;
      this.mapData = [];
      console.log(this.TalksMap.markerLayer);
      if (this.TalksMap.landLayer || this.TalksMap.markerLayer) {
        this.TalksMap.landLayer.clear();
        this.TalksMap.markerLayer.clear();
      }
      this.$http.nqMonitor
        .monitorDevice({
          type: this.monitorTypeId,
          masterId: this.MasterId,
          searchName: this.SearchName,
        })
        .then((res) => {
          console.log('289',res);
          this.loadingFlag = false;
          if (res.data.length > 0) {
            this.mapData = res.data;
            this.deviceData = res.data;
            let Coordinate;
            var listPosinArr = res.data;
            if (listPosinArr.length > 0) {
              let centroidArr = JSON.parse(listPosinArr[0].centroid);
              if (listPosinArr.length > 0) {
                Coordinate = {
                  x: Number(centroidArr[0]),
                  y: Number(centroidArr[1]),
                };
              }
              this.TalksMap.map.setCenter(Coordinate);
              this.drawPolygon();
            }
          } else {
            this.deviceData = [];
          }
        })
        .catch((err) => {
          this.loadingFlag = false;
        });
    },
    //渲染地块
    drawPolygon() {
      console.log('295',this.mapData);
      if (this.mapData && this.mapData.length > 0) {
        if (this.TalksMap.landLayer) {
          this.TalksMap.landLayer.clear();
        }
        console.log(this.mapData);
        for (var i = 0; i < this.mapData.length; i++) {
          let landArr = [];
          if (this.mapData[i].croplandEdge != null) {
            let mapEdge = JSON.parse(this.mapData[i].croplandEdge);
            if (mapEdge[0][0] && mapEdge[0][0][0]) {
              landArr = mapEdge[0];
              let multiPolygon = new maptalks.Polygon(landArr, {
                visible: true,
                editable: true,
                cursor: null,
                shadowBlur: 0,
                shadowColor: "black",
                draggable: false,
                dragShadow: false,
                drawOnAxis: null,
                symbol: {
                  lineColor: "#00999f",
                  lineWidth: 2,
                  polygonFill: "#00999f",
                  polygonOpacity: 0.5,
                },
                properties: this.mapData[i],
              });
              // multiPolygon.on("click", this.landCallBack);

              multiPolygon.addTo(this.TalksMap.landLayer);
            }
          }
        }
        this.setMarker();
      } else {
        this.TalksMap.landLayer.clear();
      }
    },
    //弹窗视频关闭 右侧透明栏视频播放
    flagVideo(val) {
      this.$refs.rightDevice.getVideoUrl();
    },
    //地块信息
    landCallBack(e) {
      // 点击地块清空设备选中颜色
      this.setMarker();
      this.showRightInfo = true;
      this.showDeviceInfo = false;
      this.curPolygonVal = e.target.properties;
      this.landId = e.target.properties.id;
      for (var i = 0; i < this.TalksMap.landLayer._geoList.length; i++) {
        this.TalksMap.landLayer._geoList[i].setSymbol({
          lineColor: "#00999f",
          lineWidth: 2,
          polygonFill: "#00999f",
          polygonOpacity: 0.5,
        });
      }
      e.target.setSymbol({
        polygonFill: "#00999f",
        lineWidth: 2,
        lineColor: "#00999f",
        polygonOpacity: 0.5,
      });
    },
    //地图上设置marker
    setMarker() {
      var this_ = this;
      console.log(this.deviceData);
      if (this.deviceData && this.deviceData.length > 0) {
        var marker;
        if (this.TalksMap.markerLayer) {
          this.TalksMap.markerLayer.clear();
        }
        for (var i = 0; i < this.deviceData.length; i++) {
          let markerList = this.deviceData[i].deviceList;
          console.log(markerList);
          if (markerList.length > 0) {
            for (var j = 0; j < markerList.length; j++) {
              console.log(markerList[j].deviceTypeId);
              console.log(markerList[j].lon);
              console.log(markerList[j].lat);
              let iconUrl = "";
              if (markerList[j].deviceTypeId == 10) {
                iconUrl = require("@/assets/agricultural/nqfont/gray1.png");
                // iconUrl = require("");
              } else if (markerList[j].deviceTypeId == 20) {
                iconUrl = require("@/assets/agricultural/nqfont/gray2.png");
              } else if (markerList[j].deviceTypeId == 40) {
                iconUrl = require("@/assets/agricultural/nqfont/gray3.png");
              } else if (markerList[j].deviceTypeId == 30) {
                iconUrl = require("@/assets/agricultural/nqfont/gray4.png");
              } else {
                iconUrl = "";
              }
              if (iconUrl != "") {
                let poi = [
                  Number(markerList[j].lon),
                  Number(markerList[j].lat),
                ];
                console.log(poi);
                marker = new maptalks.Marker(poi, {
                  symbol: [
                    {
                      markerFile: iconUrl,
                      // markerWidth: '10%',
                      // markerHeight: 65,
                      markerOpacity: 1,
                    },
                  ],
                });
                console.log(this_.TalksMap);
                marker.addTo(this_.TalksMap.markerLayer);
                marker.val = markerList[j];
                marker.on("click", this_.markerClick);
              }
            }
          }
        }
      }
    },
    // 地图上农情设备点击
    markerClick(e) {
      // 点击设备清空地块选中颜色
      for (var i = 0; i < this.TalksMap.landLayer._geoList.length; i++) {
        this.TalksMap.landLayer._geoList[i].setSymbol({
          lineColor: "#00999f",
          lineWidth: 2,
          polygonFill: "#00999f",
          polygonOpacity: 0.5,
        });
      }
      this.targetId = e.target.val.deviceTypeId;
      this.edition = e.target.val.edition;
      let markerPoints = this.TalksMap.markerLayer._geoList;
      let iconLightUrl;
      this.showDeviceInfo = true;
      this.showRightInfo = false;
      let deviceTypeName = "";
      for (var j = 0; j < markerPoints.length; j++) {
        if (this.targetId == 10) {
          iconLightUrl = require("@/assets/agricultural/nqfont/green1.png");
          deviceTypeName = "环境监测";
        } else if (this.targetId == 20) {
          iconLightUrl = require("@/assets/agricultural/nqfont/green2.png");
          deviceTypeName = "土壤监测";
        } else if (this.targetId == 40) {
          iconLightUrl = require("@/assets/agricultural/nqfont/green3.png");
          deviceTypeName = "视频监测";
        } else if (this.targetId == 30) {
          iconLightUrl = require("@/assets/agricultural/nqfont/green4.png");
          deviceTypeName = "长势监测";
        }
        let icons;
        if (markerPoints[j].val.deviceTypeId == 10) {
          icons = require("@/assets/agricultural/nqfont/gray1.png");
        }
        if (markerPoints[j].val.deviceTypeId == 20) {
          icons = require("@/assets/agricultural/nqfont/gray2.png");
        }
        if (markerPoints[j].val.deviceTypeId == 40) {
          icons = require("@/assets/agricultural/nqfont/gray3.png");
        }
        if (markerPoints[j].val.deviceTypeId == 30) {
          icons = require("@/assets/agricultural/nqfont/gray4.png");
        }
        markerPoints[j].setSymbol({
          markerFile: icons,
          // markerWidth: '10%',
          // markerHeight: 65,
          markerOpacity: 1,
        });
      }
      e.target.setSymbol({
        markerFile: iconLightUrl,
        // markerWidth: '10%',
        // markerHeight: 65,
        markerOpacity: 1,
      });
      this.farmAllData = {
        deviceTypeName: deviceTypeName,
        deviceCode: e.target.val.deviceCode,
        deviceTypeId: e.target.val.deviceTypeId,
        edition: e.target.val.edition,
        deviceName: e.target.val.reserveOne,
      };
      sessionStorage.setItem("farmAllData", JSON.stringify(this.farmAllData));
    },
    //环境监测切卡
    handleFilterDevice(index, item) {
      this.currentIndex = index;
      this.monitorTypeId = item.deviceTypeId;
      this.showDeviceInfo = false;
      this.showRightInfo = false;
      this.getMapData();
    },
    // 切换右侧设备弹框
    handleChangeDeviceInfo() {
      this.showDeviceInfo = false;
    },
    // 切换右侧地块信息弹框
    handleChangeRightInfo() {
      this.showRightInfo = false;
    },
  },
};
